import { createContext } from 'react';

/** What the user asked for. `system` follows the operating system. */
export type ThemePreference = 'light' | 'dark' | 'system';

/** What is actually on screen once `system` has been resolved. */
export type ResolvedTheme = 'light' | 'dark';

/** The theme state and the one operation that changes it. */
export interface ThemeContextValue {
  /** The stored preference. */
  readonly preference: ThemePreference;
  /** The theme in effect. */
  readonly resolved: ResolvedTheme;
  /** Stores a new preference and applies it. */
  readonly setPreference: (preference: ThemePreference) => void;
}

/** Where the preference is remembered between visits. */
export const THEME_STORAGE_KEY = 'fieldops.theme';

/** The attribute the stylesheet keys off. */
export const THEME_ATTRIBUTE = 'data-theme';

export const ThemeContext = createContext<ThemeContextValue | null>(null);
